var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9836 15.9791V18.3877C19.9846 18.6113 19.9388 18.8327 19.8492 19.0376C19.7596 19.2424 19.6282 19.4263 19.4634 19.5775C19.2987 19.7287 19.1041 19.8438 18.8923 19.9154C18.6805 19.987 18.4561 20.0136 18.2334 19.9935C15.7628 19.7251 13.3896 18.8808 11.3045 17.5287C9.36459 16.296 7.7199 14.6513 6.4872 12.7114C5.13031 10.6168 4.2859 8.23209 4.02236 5.75039C4.00229 5.52836 4.02868 5.30459 4.09983 5.09333C4.17099 4.88206 4.28536 4.68792 4.43565 4.52328C4.58595 4.35863 4.76888 4.22709 4.9728 4.13701C5.17672 4.04694 5.39716 4.00031 5.62009 4.0001H8.02874C8.41838 3.99627 8.79612 4.13425 9.09156 4.38832C9.387 4.6424 9.57996 4.99523 9.6345 5.38106C9.73616 6.15188 9.9247 6.90873 10.1965 7.63716C10.3045 7.92453 10.3279 8.23684 10.2639 8.53709C10.1998 8.83734 10.0511 9.11294 9.83522 9.33124L8.81556 10.3509C9.95851 12.3609 11.6228 14.0252 13.6329 15.1682L14.6525 14.1485C14.8708 13.9327 15.1464 13.7839 15.4467 13.7199C15.7469 13.6558 16.0592 13.6792 16.3466 13.7872C17.075 14.059 17.8319 14.2476 18.6027 14.3493C18.9927 14.4043 19.3489 14.6007 19.6035 14.9012C19.8581 15.2017 19.9934 15.5853 19.9836 15.9791Z",
    stroke: "#00000099",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.85f068aa0ee3b349a8e948007397e2d4.svg";
export { ForwardRef as ReactComponent };